import { render, staticRenderFns } from "./BigDataSelectItem.vue?vue&type=template&id=50619d48&scoped=true"
import script from "./BigDataSelectItem.vue?vue&type=script&lang=js"
export * from "./BigDataSelectItem.vue?vue&type=script&lang=js"
import style0 from "./BigDataSelectItem.vue?vue&type=style&index=0&id=50619d48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50619d48",
  null
  
)

export default component.exports